import { render, staticRenderFns } from "./Plans.vue?vue&type=template&id=d6ddd1ac&scoped=true"
import script from "./Plans.vue?vue&type=script&lang=ts"
export * from "./Plans.vue?vue&type=script&lang=ts"
import style0 from "./Plans.vue?vue&type=style&index=0&id=d6ddd1ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6ddd1ac",
  null
  
)

export default component.exports